import { map, Observable } from 'rxjs';

/**
 * Throws the error built by `errorFn` if `conditionFn` evaluates to be truthy.
 *
 * @param conditionFn Determines if an error should be thrown.
 * @param errorFn Evaluates to the error which can be thrown.
 *
 */
// eslint-disable-next-line no-restricted-syntax -- the factory may return an Error or any other value the caller wants thrown
export function throwIf<T>(conditionFn: (value: T, index: number) => boolean, errorFn: (value: T, index: number) => unknown) {
  return (input: Observable<T>) =>
    input.pipe(
      map((value, index) => {
        if (conditionFn(value, index)) {
          throw errorFn(value, index);
        }

        return value;
      }),
    );
}
